import StepTwoIcon from './component.jsx'
export default StepTwoIcon
